/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface PreviewInterviewRequest
 */
export interface PreviewInterviewRequest {
  /**
   *
   * @type {string}
   * @memberof PreviewInterviewRequest
   */
  jamieMeetingId: string;
}

/**
 * Check if a given object implements the PreviewInterviewRequest interface.
 */
export function instanceOfPreviewInterviewRequest(
  value: object,
): value is PreviewInterviewRequest {
  if (!("jamieMeetingId" in value) || value["jamieMeetingId"] === undefined)
    return false;
  return true;
}

export function PreviewInterviewRequestFromJSON(
  json: any,
): PreviewInterviewRequest {
  return PreviewInterviewRequestFromJSONTyped(json, false);
}

export function PreviewInterviewRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PreviewInterviewRequest {
  if (json == null) {
    return json;
  }
  return {
    jamieMeetingId: json["jamieMeetingId"],
  };
}

export function PreviewInterviewRequestToJSON(
  json: any,
): PreviewInterviewRequest {
  return PreviewInterviewRequestToJSONTyped(json, false);
}

export function PreviewInterviewRequestToJSONTyped(
  value?: PreviewInterviewRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    jamieMeetingId: value["jamieMeetingId"],
  };
}
